
import { Options, Vue } from "vue-class-component";

@Options({})
export default class RgbaToHex extends Vue {
  rValue = 69;
  gValue = 202;
  bValue = 88;
  aValue = 0.85;
  colorCalculated = '';
  colorCalculatedWithoutTrans = {
    r: 0,
    g: 0,
    b: 0
  };

  mounted() {
    this.colorCalculatedString();
  }

  changeColorCalculatedString() {
    const rgb = this.colorCalculated.match(
      /rgba\(\s*(-?\d+|-?\d*\.\d+(?=%))(%?)\s*,\s*(-?\d+|-?\d*\.\d+(?=%))(\2)\s*,\s*(-?\d+|-?\d*\.\d+(?=%))(\2)\s*,\s*(-?\d+|-?\d*.\d+)\s*\)/
    );
    if (rgb && rgb[1]) {
      const rValue: number = +rgb[1]
      this.rValue = rValue
    }
    if (rgb && rgb[3]) {
      const gValue: number = +rgb[3]
      this.gValue = gValue
    }
    if (rgb && rgb[5]) {
      const bValue: number = +rgb[5]
      this.bValue = bValue
    }
    if (rgb && rgb[7]) {
      const aValue: number = +rgb[7]
      this.aValue = aValue
    }
    this.colorCalculatedString();
  }

  colorCalculatedString() {
    this.colorCalculated =
      "rgba(" +
      this.rValue +
      "," +
      this.gValue +
      "," +
      this.bValue +
      "," +
      this.aValue +
      ")";
      this.colorCalculatedWithoutTrans.r = this.rValue
      this.colorCalculatedWithoutTrans.g = this.gValue
      this.colorCalculatedWithoutTrans.b = this.bValue
    this.convert();
  }

  convert() {
    const rgb = this.colorCalculated.match(
      /rgba\(\s*(-?\d+|-?\d*\.\d+(?=%))(%?)\s*,\s*(-?\d+|-?\d*\.\d+(?=%))(\2)\s*,\s*(-?\d+|-?\d*\.\d+(?=%))(\2)\s*,\s*(-?\d+|-?\d*.\d+)\s*\)/
    );
    const color =
      rgb && rgb.length === 8
        ? "#" +
          ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
          ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) +
          ("0" + parseInt(rgb[5], 10).toString(16)).slice(-2)
        : "";
    let zusatz;
    if (rgb && rgb.length === 8) {
      const prozent: number = +rgb[7] * 100
      const prozentwert = Math.round(prozent * 255 / 100)
      zusatz = prozentwert.toString(16)
    }
    if (color)
      this.$emit("colorRgba", {
        color: color,
        colorTransparenz: zusatz,
        colorCalculated: this.colorCalculated,
        colorCalculatedWithoutTrans: this.colorCalculatedWithoutTrans
      });
  }
}
